module.exports = __webpack_public_path__ + "assets/img/7db152c0c5894de2b43fc3cbb52ceedb.jpg";